import React from 'react';
import Content from 'components/_ui/Content';
import styled from '@emotion/styled';
import dimensions from 'styles/dimensions';
import { Inner, gridColumns } from 'styles/structure';
/*import colors from 'styles/colors';*/

const ColumnsContainer = styled.div`
  & + * {
    margin-top: 6.4rem;
  }
  
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    & + * {
      margin-top: 12rem;
    }  
  }
`;

const ColumnsList = styled.ul`
  li {
    & + * {
      margin-top: 14vw;
    }
  }
  
  h4 {
    & + * {
      margin-top: 1.6rem;
    }
  }
  
  p {
    max-width: 72.8rem;
  }
  
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    
    li {
      ${gridColumns('1/3', 8)}
      
      & + * {
        margin-top: 0;
        margin-left: 8rem;
      }
      
      &:nth-of-type(n+4) {
        margin-top: 8rem;
      }
      
      &:nth-child(3n+1) {
        margin-left: 0;
      }
    }
    
    h4 {
      & + * {
        margin-top: 2.4rem;
      }
    }
  }
`;

const ColumnsImage = styled.img`
  display: block;
  width: 66.6667%;
  max-width: 100%;
  margin: 0 auto 3.2rem;
  
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    width: 100%;
    margin-bottom: 8rem;
  }
`;

const ContentColumns = ({ items, variant }) => {
  return (
    <ColumnsContainer className={variant && `ContentColumns--${variant}`}>
      <Inner>
        <ColumnsList>
        {items && items.map((column, i) => (
          <li key={i}>
            {column.image && <ColumnsImage src={column.image.url} alt={column.image.alt}/>}
            {column.heading && <h4>{column.heading}</h4>}
            {column.content && <Content content={column.content}/>}
          </li>
        ))}
        </ColumnsList>
      </Inner>
    </ColumnsContainer>
  );
};

export default ContentColumns;
